import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-user-profile-avatar',
  templateUrl: './user-profile-avatar.component.html',
  styleUrls: ['./user-profile-avatar.component.scss']
})
export class UserProfileAvatarComponent {
  @Input() user!: string;

  getAvatarLetters() {
    return this.user.split(' ').map(e => e [0]).join('').toUpperCase()
  }
}
